import LateActivitiesCounter from "./LateActivitiesCounter";

export default LateActivitiesCounter;
